import { isEmpty } from 'lodash/fp';
import { defaultMemoize as memoizeOne } from 'reselect';

import { Touchable } from '../@types/touchable';

/**
 * Parses query params. Uses URLSearchParams
 * @see https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
 * @param {string} params may contain leading '?'
 * @return {object} parsed parameters
 */
export const parseQueryParams = memoizeOne(function parseQueryParams(params) {
	return !params ? {} : Object.fromEntries(new URLSearchParams(params).entries());
});

/**
 * Encodes record to query params string. Uses URLSearchParams
 * @see https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
 * plus for keys with empty values use null value - eg. { abt: null } will be encoded as '?abt'
 * @param {object} params object
 * @return {string}
 */
export function encodeQueryParams(params) {
	return isEmpty(params) ? `` : new URLSearchParams(params).toString().replace(/=null/g, '');
}

export const stripHostname = (absoluteUrl: string | URL): string => {
	const url = new URL(absoluteUrl);
	return [url.pathname, url.search, url.hash].filter(Boolean).join(``);
};

const absoluteLinkRe = /^https?:\/\//;
export const isAbsoluteURL = RegExp.prototype.test.bind(absoluteLinkRe);

export const stripPathname = (url: string | Touchable['to'] | URL): string | null => {
	if (typeof url !== 'string' && url?.pathname) {
		return url.pathname;
	}

	if (typeof url === 'string') {
		const urlObject = new URL(url, 'https://dummy.url');
		return urlObject.pathname;
	}

	return null;
};
